import { getLeFEOrigin } from '@utils/util';

export const ContractManagerLeFE = () => (
    <iframe className="admin-iframe" title="合同管理" src={`${getLeFEOrigin()}/#/app/admin/contract`} />
);
